import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Layout, Icon, Button, Dropdown, Menu, Modal, Form, Input, message as Message } from 'antd';
import appRs from '../../App.reducer'
import { SET_SIDER } from '../../App.action'
import Cookies from 'js-cookie';
import { logout, updatePassword, returnToSysAdmin, merchantChangeTo } from '../../api'
import common from '../../util/common.js'
import SchoolSelect from '../../components/SchoolSelect'

const { Header } = Layout;
class AppHeader extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
        }
        // hotfix 方案 在这里导出history
        window.browserHistory = props.history
    }

    toggleModal = (flag) => {
        this.setState({
            showModal: flag
        })
    }

    toggle = () => {
        let sider = this.props.appRs.sider
        sider.collapsed = !sider.collapsed
        this.props.dispatch({
            type: SET_SIDER,
            sider
        })
    }

    // 超管切换到学校账户后再次切换回超管
    returnTo = () => {
        returnToSysAdmin().then(() => {
            if (window.location.href.includes('localhost')) {
                window.location.href = "/overview";
            }
            else {
                window.location.href = "/qrpos/pages/admin/overview.html";
            }
        })
    }

    onClick = ({ item, key, keyPath }) => {
        if (key === '0') {
            // 修改密码
            this.toggleModal(true)
        } else if (key === '2'){
            this.props.history.push('/account')
        } else {
            // 退出
            sessionStorage.clear()
            Cookies.remove("auth_phone");
            logout().then(({result}) => {
                let identity = this.props.appRs.userInfo.identity
                common.delCookie("limit");
                if(result !== null) {
                   window.location.href = result;
                } else if (identity === 'Agent') {
                    window.location.href = "/login?type=agent";
                } else {
                    window.location.href = "/login";
                }
            })
        }
    }

    updatePassword = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let identity = this.props.appRs.userInfo.identity
                updatePassword(values, identity).then(({ status, message }) => {
                    if (status === 200) {
                        Message.info("修改成功");
                        setTimeout(() => {
                            if (identity === 'Agent') {
                                window.location.href = "/login?type=agent";
                            } else {
                                window.location.href = "/login";
                            }
                        }, 3000)
                    } else {
                        Message.info(message);
                    }
                })
            }
        });
    }

    render() {
        const { location, appRs: { sider, userInfo, orgList } } = this.props
        let onSelectChange = async (orgId) => {
            await merchantChangeTo({orgId});
            window.location.href = window.location.href;
            // window.location.reload();
        }
        if (!userInfo || userInfo.identity === 'Guest') {
            return null
        }
        const { getFieldDecorator } = this.props.form;
        return location.pathname !== '/login' && <Header style={{ width: 'calc(100% - ' + (sider.collapsed ? sider.collapsedWidth : sider.width) + 'px)' }}>
            <Icon
                className="trigger"
                type={sider.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
            />
            <span style={{ fontSize: 16, fontWeight: 500 }}>
                {userInfo.orgName}
            </span>
            <span className="pull-right">
                {orgList.length >= 1 && <SchoolSelect style={{ width: 200, marginRight: 8 }} orgList={orgList} onSelectChange={(orgId) => onSelectChange(orgId) }></SchoolSelect>}
                {userInfo.source && <Button icon="arrow-left" style={{opacity: 0}} onClick={this.returnTo}></Button>}
                <Dropdown overlay={<Menu onClick={this.onClick}>
                    {/*
                        !userInfo.identity.includes("Agent") &&
                        <Menu.Item key="0">
                            修改密码
                        </Menu.Item>*/
                    }
                    {
                        !userInfo.identity.includes("Agent") &&
                        <Menu.Item key="2">
                            账号管理
                        </Menu.Item>
                    }
                    <Menu.Item key="1">
                        退出
                    </Menu.Item>
                </Menu>}>
                    <span className="ant-dropdown-link">
                        {/* <Avatar size={24} src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" /> */}
                        {userInfo.userName || userInfo.name} <Icon type="down" />
                    </span>
                </Dropdown>
            </span>
            <Modal
                title="修改密码"
                visible={this.state.showModal}
                onOk={this.updatePassword}
                okText="修改"
                destroyOnClose
                onCancel={() => this.toggleModal(false)}
            >
                <Form>
                    <Form.Item label="旧密码" labelCol={{ span: 5 }} wrapperCol={{ span: 12 }}>
                        {getFieldDecorator('passWord', {
                            rules: [{
                                required: true, message: '请填写旧密码',
                            }],
                        })(
                            <Input type="password" />
                        )}
                    </Form.Item>
                    <Form.Item label="新密码" labelCol={{ span: 5 }} wrapperCol={{ span: 12 }}>
                        {getFieldDecorator('newPassWord', {
                            rules: [{
                                required: true, message: '请填写新密码',
                            }, {
                                min: 6, max: 40, message: '密码长度为[6-40]',
                            }],
                        })(
                            <Input type="password" maxLength={40} />
                        )}
                    </Form.Item>
                    <Form.Item label="重复密码" labelCol={{ span: 5 }} wrapperCol={{ span: 12 }}>
                        {getFieldDecorator('newPassWord2', {
                            rules: [{
                                required: true, message: '请重复填写新密码',
                            }, {
                                min: 6, max: 40, message: '密码长度为[6-40]',
                            }, {
                                validator: (rule, value, callback) => {
                                    if (value && value !== this.props.form.getFieldValue('newPassWord')) {
                                        callback('新密码不一致');
                                    } else {
                                        callback();
                                    }
                                },
                            }],
                        })(
                            <Input type="password" maxLength={40} />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        </Header>
    }
}

export default withRouter(connect(appRs)(Form.create()(AppHeader)))



// WEBPACK FOOTER //
// ./src/components/AppHeader/index.jsx